import { axiosInstance } from "../index";

const addFlashCardTopic = async (params) => {
  return await axiosInstance.post(`/flashcard_topics`, params);
};

const getAllFlashCardTopic = async (params) => {
  return await axiosInstance.get(`/flashcard_topics`, { params });
};

const editFlashCardTopic = async ({ id, ...params }) => {
  return await axiosInstance.patch(`/flashcard_topics/${id}`, params);
};

const deleteFlashCardTopic = async (id) => {
  return await axiosInstance.delete(`/flashcard_topics/${id}`);
};
const getSingleFlashCardTopic = async (id) => {
  return await axiosInstance.get(`/flashcard_topics/${id}`);
};
// sub-topic
const getAllFlashCardSubTopics = async ({ topicId, ...params }) =>
  await axiosInstance.get(
    `/flashcard_topics/${topicId}/flashcard_sub_topics`,
    { params }
  );

const addFlashCardSubTopics = async ({ topicId, ...params }) =>
  await axiosInstance.post(
    `/flashcard_topics/${topicId}/flashcard_sub_topics`,
    params
  );

const getSingleFlashCardSubTopic = async ({ topicId, id }) =>
  await axiosInstance.get(
    `/flashcard_topics/${topicId}/flashcard_sub_topics/${id}`
  );

const editFlashCardSubTopic = async ({ topicId, id, ...params }) =>
  await axiosInstance.patch(
    `/flashcard_topics/${topicId}/flashcard_sub_topics/${id}`,
    params
  );

const deleteFlashCardSubTopic = async ({ topicId, id }) =>
  await axiosInstance.delete(
    `/flashcard_topics/${topicId}/flashcard_sub_topics/${id}`
  );

export {
  addFlashCardTopic,
  getAllFlashCardTopic,
  editFlashCardTopic,
  deleteFlashCardTopic,
  getSingleFlashCardTopic,
  // sub-topic
  getAllFlashCardSubTopics,
  addFlashCardSubTopics,
  getSingleFlashCardSubTopic,
  editFlashCardSubTopic,
  deleteFlashCardSubTopic
};
